import { RedirectDto } from "@intelligems/ig-types";

export const getSpecificRedirectsUtil = (
  redirects: RedirectDto[],
  redirectType: "template" | "theme" | "url"
) => {
  switch (redirectType) {
    case "template":
      return redirects.filter((redirect) => redirect.isTemplateTest);
    case "theme":
      return redirects.filter((redirect) => redirect.isThemeTest);
    case "url":
      return redirects.filter(
        (redirect) => !redirect.isTemplateTest && !redirect.isThemeTest
      );
    default:
      return redirects;
  }
};
